import * as React from 'react';
import { ISnackbarData } from '@yakoffice/snackbar';

export const SnackbarContext = React.createContext<(snackbarData: ISnackbarData) => void>(
    () => {
        return;
    });
